import Api from './api';

const portsOfLoadingListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/pols', {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createPortOfLoadingRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/pols/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deletePortOfLoadingRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/pols/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}


export default { portsOfLoadingListRequest, createPortOfLoadingRequest, deletePortOfLoadingRequest }



// WEBPACK FOOTER //
// ./src/api/apiPortsOfLoading.js